import React, { useEffect, useState, useContext, useRef} from "react";
import '@ds/ds-snam';
import logo from "shared/assets/logo.svg";
//import { ActionButton } from "@ds/ds-snam/react";
import { DsLayout, LANGUAGES, /*ILanguage,*/ LanguageKey, RoutePath, SNAM_PLANTS, SnamPlantKey } from "shared/constants";
import { useTranslation } from "react-i18next";
import { setAxiosHeader } from "shared/utils/axiosUtils";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { ActionButton, Avatar, Output, ProfileMenu, TopBarV2Item } from "@ds/ds-snam/react";
import { useNavigate } from "react-router";
import { setPlant } from "state/reducer/plantSlice";
import axios from "axios";
import { Authenticator } from "ooAuth2/authenticator";
import useWindowWidth from "hooks/useWindowWidth";


const MainHeader: React.FC = (): JSX.Element => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const {t} = useTranslation(['app']);
  const [showLangMenu, setShowLangMenu] = useState<boolean>(false);
  const [showPlantMenu, setShowPlantMenu] = useState<boolean>(false);
  const [showProfileMenu, setShowProfileMenu] = useState<boolean>(false);
  const appUser:AppUser|undefined = useAppUser();
  const authenticator: Authenticator = new Authenticator();
  const width = useWindowWidth();
  const navigate = useNavigate();
  const profileMenuRef = useRef<HTMLDivElement>(null);
  const languageMenuRef = useRef<HTMLDivElement>(null);
  const plantMenuRef = useRef<HTMLDivElement>(null);
  const profileButtonRef = useRef<HTMLDivElement>(null);
  const languageButtonRef = useRef<HTMLDivElement>(null);
  const plantButtonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node;
    
      if (
        showProfileMenu &&
        profileMenuRef.current &&
        !profileMenuRef.current.contains(target) &&
        !profileButtonRef.current?.contains(target)
      ) {
        setShowProfileMenu(false);
      }
    
      if (
        showLangMenu &&
        languageMenuRef.current &&
        !languageMenuRef.current.contains(target) &&
        !languageButtonRef.current?.contains(target)
      ) {
        setShowLangMenu(false);
      }
    
      if (
        showPlantMenu &&
        plantMenuRef.current &&
        !plantMenuRef.current.contains(target) &&
        !plantButtonRef.current?.contains(target)
      ) {
        setShowPlantMenu(false);
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfileMenu, showLangMenu, showPlantMenu]);
  //PROFILE LOGIC
  const myMenuItemsConfig = {
    "items":[
      /*{ 
        "id":"linkprofile0",
        "hasDispatchEvent":true,
        "itemName":"Dati account",
        "isExternal":false,
        "url":"https://localhost:6007",
        "ariaLabel":"aria label",
        "isActive":false
      },
      { 
        "id":"linkprofile0",
        "hasDispatchEvent":true,
        "itemName":"Gestione privacy",
        "isExternal":false,
        "url":"https://localhost:6007",
        "ariaLabel":"aria label",
        "isActive":false
      },
      { 
        "id":"linkprofile0",
        "hasDispatchEvent":true,
        "itemName":"Termini e condizioni",
        "isExternal":false,
        "url":"https://localhost:6007",
        "ariaLabel":"aria label",
        "isActive":false
      },*/
      { 
        "id":"linkprofile0",
        "hasDispatchEvent":true,
        "itemName":"Esci",
        "isExternal":false,
        "url":"https://localhost:6007",
        "ariaLabel":"aria label",
        "isActive":false,
        "hasTopDivider":true,
        "icon":"icon-leave"
      },
    ]
  }


  //LANGUAGE LOGIC
  const handleLanguageChange = (selectedLanguageId: string) => {
    setMenuLanguageConfig(prevConfig => ({
      ...prevConfig,
      items: prevConfig.items.map(item => ({
        ...item,
        isActive: item.id === selectedLanguageId
      }))
    }));
  };
  const myMenuLanguageConfig = {
    "items":[
      { 
        "id":"it",
        "hasDispatchEvent":true,
        "itemName":"Italiano",
        "isExternal":false,
        "url":"https://localhost:3000",
        "ariaLabel":"aria label",
        "isActive":false,
        "icon":"icon-flag-italy-colored"
      },
      { 
        "id":"en",
        "hasDispatchEvent":true,
        "itemName":"English",
        "isExternal":false,
        "url":"https://localhost:3000",
        "ariaLabel":"aria label",
        "isActive":false,
        "icon":"icon-flag-uk-colored"
      }
    ]
  }
  const [menuLanguageCofig,setMenuLanguageConfig] = useState(myMenuLanguageConfig);
  useEffect(() => {
    // This will be now called when the locale is changed
    //console.log(i18n.language)
    const newLang: string = LANGUAGES.get(i18n.language)!.id!;
    setAxiosHeader("Accept-Language", newLang);
    handleLanguageChange(newLang);
  }, [i18n.language]);


  //PLANT LOGIC
  const userPlants = appUser!.getPlants(); // Ottieni il vettore dall'utente
  const plantId = useSelector((state:RootState)=>{
    return state.plant.plantId;
  });
  const allPlants = [
    { 
      id: SnamPlantKey.PANIGAGLIA,
      hasDispatchEvent: true,
      itemName: "Panigaglia",
      isExternal: false,
      url: "https://localhost:3000",
      ariaLabel: "aria label",
      isActive: false
    },
    { 
      id: SnamPlantKey.PIGNATARO,
      hasDispatchEvent: true,
      itemName: "Pignataro",
      isExternal: false,
      url: "https://localhost:3000",
      ariaLabel: "aria label",
      isActive: false
    }
  ];
  let myMenuPlantConfig = {
    items: allPlants.filter((_, index) => userPlants!.includes(index + 1))
  };
  const myMenuPlantConfigTablet = myMenuPlantConfig.items.map(plant => ({
    id: plant.id,
    label: plant.itemName,
    isDisabled: false
  }));
  const [menuPlantConfig,setMenuPlantConfig] = useState(myMenuPlantConfig);
  const handlePlantChange = (selectedPlantId: string) => {
    setMenuPlantConfig(prevConfig => ({
      ...prevConfig,
      items: prevConfig.items.map(item => ({
        ...item,
        isActive: item.id === selectedPlantId
      }))
    }));
  };
  useEffect(() => {
    if(plantId!==undefined){
      handlePlantChange(plantId);
    }
  }, [plantId]);
  

  const actionClickPanigaglia = () => {
    dispatch(setPlant({plantId:SnamPlantKey.PANIGAGLIA}));
    //set axios header plantId
    delete axios.defaults.headers.common['plantId']; 
    setAxiosHeader('plantId', SnamPlantKey.PANIGAGLIA);
    setShowPlantMenu(false);
    navigate(RoutePath.ROOT, { replace: true });
  }
  const actionClickPignataro = () => {
  dispatch(setPlant({plantId:SnamPlantKey.PIGNATARO}));
  //set axios header plantId
  delete axios.defaults.headers.common['plantId']; 
  setAxiosHeader('plantId', SnamPlantKey.PIGNATARO);
  setShowPlantMenu(false);
  navigate(RoutePath.ROOT, { replace: true });
  }

  const actionClickItaliano = () => {
    i18n.changeLanguage(LANGUAGES.get(LanguageKey.IT)!.id!);
    setShowLangMenu(false);
  }

  const actionClickEnglish = () => {
    i18n.changeLanguage(LANGUAGES.get(LanguageKey.EN)!.id!);
    setShowLangMenu(false);
  }
  
  return (<>
      
    <div className="ds-top-bar-example" style={{ position: "fixed" }}>
     
      <div className="ds-footer__logo">
        <img src={logo} alt="logo" style={{ width: "40px", height: "40px",cursor:'pointer' }} onClick={()=>{
          navigate(RoutePath.DASHBOARD)
        }} />
        <div className="ds-top-bar-example__label ff-lato-body2-w400">SSNLG</div>
      </div>


      <div className="ds-top-bar-example__container-icon" style={{}}>
            
        
        <div className="ds-footer__logo">
          {/**
          * BTN PLANT
        */}
          {plantId && width > 1024 && <div ref={plantButtonRef}style={{cursor:'pointer',width:'120px',marginRight:'20px',marginBottom:'5px'}} onClick={() => {
              setShowPlantMenu(!showPlantMenu);
            }}>
                {<Output
                  leftIcon={showPlantMenu?"icon-headquarters-filled":"icon-headquarters"}
                  outputText={width > 1024?(plantId===SnamPlantKey.PANIGAGLIA?"Panigaglia":"Pignataro"):""}
                  rightIcon={showPlantMenu ? "icon-chevron-up-filled" : "icon-chevron-down"}
                ></Output>}
          </div>}
          {plantId && width < 1024 && 
            <>
            <ActionButton
              actionsType="button"
              buttonLabel={(plantId===SnamPlantKey.PANIGAGLIA?"Panigaglia":"Pignataro")}//"Azioni"
              buttonVariant="secondary"
              buttonAriaLabel="action button aria text"
              menuAriaLabel="menu aria text"
              menuTitle="Plant"
              menuActions={myMenuPlantConfigTablet
                  /*[
                      {
                          id: SnamPlantKey.PANIGAGLIA,
                          label: "Panigaglia",
                          isDisabled:false
                      },
                      {
                          id: SnamPlantKey.PIGNATARO,
                          label: "Pignataro",
                          isDisabled:false
                      }
                  ]*/
              }
              closeMenuAriaLabel="close menu aria text"
              //isDisabled={false}
              //zIndex={999}
              onClickAction={(event: Event) => {
                const command = (event as CustomEvent).detail.actionId;
                switch (command) {
                  case SnamPlantKey.PANIGAGLIA:
                      actionClickPanigaglia();
                    break;
                  case SnamPlantKey.PIGNATARO:
                      actionClickPignataro();
                    break;
                  default:
                    break;
                }
              }}
          ></ActionButton>
          </>
        }

       

          {/**
            * BTN LINGUA
          */}
          {width > 1024 &&<div ref={languageButtonRef} style={{cursor:'pointer',width:'120px',marginRight:'20px',marginBottom:'5px'}} onClick={() => {
            setShowLangMenu(!showLangMenu);
          }}>
            <Output
              leftIcon={showLangMenu?"icon-globe-filled":"icon-globe"}
              outputText={width > 1024?(i18n.language==='it'?"Italiano":"English"):""}
              rightIcon={showLangMenu ? "icon-chevron-up" : "icon-chevron-down"}
            ></Output>
          </div>}
          { width < 1024 && 
            <div style={{marginLeft:'15px',marginRight:'15px'}}>
            <ActionButton
              actionsType="button"
              buttonLabel={(i18n.language==='it'?"Italiano":"English")}//"Azioni"
              buttonVariant="secondary"
              buttonAriaLabel="action button aria text"
              menuAriaLabel="menu aria text"
              menuTitle="Lingua"
              menuActions={
                  [
                      {
                          id: LanguageKey.IT,
                          label: "Italiano",
                          isDisabled:false
                      },
                      {
                          id: LanguageKey.EN,
                          label: "English",
                          isDisabled:false
                      }
                  ]
              }
              closeMenuAriaLabel="close menu aria text"
              //isDisabled={false}
              //zIndex={999}
              onClickAction={(event: Event) => {
                const command = (event as CustomEvent).detail.actionId;
                switch (command) {
                  case LanguageKey.IT:
                      actionClickItaliano();
                    break;
                  case LanguageKey.EN:
                      actionClickEnglish();
                    break;
                  default:
                    break;
                }
              }}
          ></ActionButton>
          </div>
        }

          
          {width > 1024 && <>{/**
            * AVATAR
          */}
          <Avatar 
            avatarType="initial" 
            fullName={appUser?.getFullName()}
            avatarSize="small"
          />
          {width > 1024 && <div className="ds-top-bar-example__container-text" style={{ alignItems: "start", marginRight: "16px" }}>
            <span className="ff-lato-body2-w400" style={{ color: "var(--text-reading-1)" }}>{appUser?.getFullName()}</span>
            <span className="ff-lato-tiny-w400" style={{ color: "var(--text-placeholder)" }}>{ t('appUser.roles.' + appUser?.userProfile?.labelKey) }</span>
          </div>}
          {/**
            * BTN PROFILO
          */}
          <div ref={profileButtonRef} onClick={() => {
            setShowProfileMenu(!showProfileMenu);
          }}>
            <ds-icon
              id="arrowTopBar"
              icon={showProfileMenu ? "icon-chevron-up" : "icon-chevron-down"}
              icon-size="medium"
              icon-filled="false"
            ></ds-icon>
          </div></>}

          {width < 1024 && <div style={{marginRight:'25px'}}>
          <ActionButton
              actionsType="button"
              buttonLabel={"Profilo"}
              buttonVariant="secondary"
              buttonAriaLabel="action button aria text"
              menuAriaLabel="menu aria text"
              menuTitle="Profilo"
              menuActions={
                  [
                      {
                          id: "Exit",
                          label: "Esci",
                          isDisabled:false
                      }
                  ]
              }
              closeMenuAriaLabel="close menu aria text"
              //isDisabled={false}
              //zIndex={999}
              onClickAction={(event: Event) => {
                const command = (event as CustomEvent).detail.actionId;
                switch (command) {
                  case "Exit":
                      //logout
                      authenticator.logoutUser(); 
                    break;
                    break;
                  default:
                    break;
                }
              }}
          ></ActionButton></div>
          }

        </div>
      </div>

      {/**
        * MENU PLANT
      */}
      {menuPlantConfig &&
        <div ref={plantMenuRef} style={{
          display: showPlantMenu ? "block" : "none",
          position: "absolute",
          right: "360px",
          top:'0px'
        }}>
          <ProfileMenu
            menuItems={menuPlantConfig}
            menuTitle={t('mainHeader.plantsMenu.title')}
            has-back-button={false}
            hasTextlinkAnimation={false}
            onClickLink={(event:Event)=>{
              const value = (event as CustomEvent).detail.id;
              //console.log(value)
              if(value===SnamPlantKey.PANIGAGLIA){
                actionClickPanigaglia();
              }else if(value===SnamPlantKey.PIGNATARO){
                actionClickPignataro();
              }
            }}
          />
        </div>
      }
      

      {/**
        * MENU LINGUA
      */}
      <div ref={languageMenuRef} style={{
        display: showLangMenu ? "block" : "none",
        position: "absolute",
        right: "230px",
        top:'0px'
      }}>
        <ProfileMenu
          menuItems={menuLanguageCofig}
          menuTitle={t('mainHeader.languageMenu.title')}
          has-back-button={false}
          hasTextlinkAnimation={false}
          onClickLink={(event:Event)=>{
            if((event as CustomEvent).detail.id==="it"){
              actionClickItaliano();
            }else if((event as CustomEvent).detail.id==="en"){
              actionClickEnglish();
            }
          }}
        />
      </div>


      {/**
        * MENU PROFILO
      */}
      <div ref={profileMenuRef} style={{
        display: showProfileMenu ? "block" : "none"
      }}>
        <ProfileMenu
          menuItems={myMenuItemsConfig}
          menuTitle="Il mio profilo"
          has-back-button={false}
          hasTextlinkAnimation={false}
          onClickLink={(event:Event)=>{
              if((event as CustomEvent).detail.id==="linkprofile0"){
                //logout
                authenticator.logoutUser(); 
              }
          }}
          
        />
      </div>

    </div >

 </> )
}

export default MainHeader;